import { DynamicThemeContext } from "../context/dynamicTheme/DynamicThemeContext";
import { useContext } from "react";

export const useDynamicTheme = () => useContext(DynamicThemeContext);
